import Navigator from 'app';
import BillModel from './bill_model';
const PassedBillsCollection = Backbone.Collection.extend({
  model: BillModel,
  url: Navigator.config.api_base + 'bills/passed'
});
const API = {
  getPassedBills: function () {
    const defer = new $.Deferred();
    const passedBills = new PassedBillsCollection();
    passedBills.fetch({
      success: function (data) {
        defer.resolve(data);
      },
      error: function (error) {
        console.error('No passed bills found');
        defer.reject(error);
      }
    });
    return defer.promise();
  }
};
Navigator.reqres.setHandler("bills:passed", function () {
  return API.getPassedBills();
});
export { PassedBillsCollection as default };